import {makeAutoObservable} from 'mobx';

export enum NotificationType {
  error = 'error',
  success = 'success',
}

interface CommonNotification {
  text: string;
}

export interface ErrorNotification extends CommonNotification {
  type: NotificationType.error;
}

export interface SuccessNotification extends CommonNotification {
  type: NotificationType.success;
}

export type Notification = ErrorNotification | SuccessNotification;

const TIMEOUT_TO_HIDE_NOTIFICATION = 8000;

export class PopUpStore {
  private timer?: NodeJS.Timeout;

  notification: Notification | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  runTimer = () => {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.setNotification(null);
    }, TIMEOUT_TO_HIDE_NOTIFICATION);
  };

  setError = (error: string) => {
    this.runTimer();

    this.setNotification({
      type: NotificationType.error,
      text: error,
    });
  };

  setSuccess = (message: string) => {
    this.runTimer();

    this.setNotification({
      type: NotificationType.success,
      text: message,
    });
  };

  setNotification(notification: Notification | null) {
    this.notification = notification;
  }

  close = () => {
    clearTimeout(this.timer);
    this.timer = undefined;

    this.setNotification(null);
  };
}
